import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { PopupService } from '../../../../services/shared/popup.service';
import { PermitTypeService } from '../../../../services/permit-type.service';
import { CurrencyFormat } from '../../../../pipes/currencyFormat.pipe';
import { environment } from '../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'app/services/application.service';
import { PermitService } from 'app/services/permit.service'
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { Account } from 'app/constants/account.enum';
import { Subject } from 'rxjs';
import { CarrierService } from 'app/services/carrier.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';

declare var $;
@Component({
  selector: 'app-app-permit-type',
  templateUrl: './app-permit-type.component.html',
  styleUrls: ['./app-permit-type.component.css'],
  providers: [PermitTypeService, PopupService, CurrencyFormat],
  encapsulation: ViewEncapsulation.None
})
export class AppPermitTypeComponent implements OnInit {

  @Input() dataCntrl: any;
  @Input('ctrlData') ctrlData: any;


  isFreight: boolean = false;
  permittype: any = [];
  selectedIndex: any;
  editMode: boolean;
  disableTypes: boolean = false;
  pageload: boolean;
  helphtml;
  linkhtml;
  vehicleTerm: any = "";
  vehicleType: any = "";
  permitType: any = "";
  referenceNum: any = "";
  selectedPermit: any = null;
  selectedPermitId: any = "";
  tabload: boolean = false;
  disableBtn: boolean = false;
  private activeTab = new Subject<number>();
  defaultValue: string;
  defaultValueType: string;
  otherPermitType: boolean = false;

  isProcess: boolean = true;
  permitDisabled: boolean = false;
  durations: any = [];
  durationSelected = null;
  typeSelected = null;

  reloadVehicle: boolean = false;
  carrierapplist:any = [];
  selectedappid: number = 0;
  maxallowedpermits: number;
  showcarapplist: boolean = false;

  canSave: boolean = false;

  changeRouteTimetable : boolean = false;
  duration:any = "";
  message = '';

  isAmend = false;
amendTerm:any;
amendType:any;

  upliftment: boolean = false;
  permitStatus7: any;
  permitStatus13: any;

  selectedDuration:any="null";
  isDuplicate:boolean=false;

  isEditMode: boolean = false;

  constructor(private sanitizer: DomSanitizer,
    public currformat: CurrencyFormat, private showModal: PopupService,
    private permitTypeService: PermitTypeService,
    public applicationService: ApplicationService, private route: ActivatedRoute,
    public utility: UtilityServiceService, private toastr: ToastrService, private router: Router,
    private permitService: PermitService,
    private activeRoute: ActivatedRoute, private carrierService: CarrierService,private confirmDialogService: ConfirmDialogService
  ) {

  }

  ngOnInit() {
    // if(this.dataCntrl.permittypeSelected == true){
    //   this.dataCntrl.formValid = true;
    // }
    this.changeRouteTimetable = this.router.url.indexOf('change') > 0;
    this.isEditMode = this.router.url.indexOf('edit') > 0 && this.router.url.indexOf('duplicate') < 0;

    this.utility.confirmCtrl = false;
    this.utility.changeKey = 0;
    //console.log(environment.authWebApi.userData.Roles);
    //console.log('Application data :',this.dataCntrl)
    this.getPermitType();
    this.setHTMLDATA();
    if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
      this.permitStatus13 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus13').Value;
    }
    if (this.dataCntrl.application.id !== undefined || this.dataCntrl.application.id !== null) {
      this.vehicleType = this.dataCntrl.vehicleType;
      this.vehicleTerm = this.dataCntrl.vehicleTerm;
      this.referenceNum = this.dataCntrl.application.reference_num;
      //console.log(this.referenceNum);
      this.durationSelected=this.dataCntrl.durationSelected;
      this.selectedPermit = this.dataCntrl.permittype;
      //console.log(this.selectedPermit);
      if(this.selectedPermit.id !== undefined){
        this.canSave = true;
      }
      this.selectedPermitId = this.selectedPermit.id;
      //console.log(this.dataCntrl.permitSelectIndex);
    }

    if (this.router.url.indexOf('edit') > 0 || this.router.url.indexOf('duplicate') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
      if(this.router.url.indexOf('duplicate') > 0){
        this.isDuplicate=true;
      }
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          this.disableBtn = true;
          //console.log('This is Admin')
        }
        if (params['type']) {
          setTimeout(() => {
            this.permitDisabled = params['type'];
            this.dataCntrl.carrierID = params['crId'];
          }, 200);
        }
      });
      this.getCarrier();
      setTimeout(() => {
        this.getApplication();
      }, 400);
    }
    if (this.router.url.indexOf('view') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        this.isProcess = false;
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          //this.disableBtn = true;
          //console.log('This is Admin')
        }
      });
      this.getApplication();
    }
    if (this.router.url.indexOf('process') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];

        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          // this.disableBtn = true;
          //console.log('This is Admin')
        }
      });
      this.getApplication();

    }
    ////console.log(this.dataCntrl.permit);
    //Processing change route
    if (this.router.url.indexOf('change') > 0 && this.router.url.indexOf('correction')<0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        const ctrlType = params['ctrlType'];
        if(ctrlType!='vehicle'){
          this.isProcess=false;
          if(!this.dataCntrl.hasOwnProperty('changeRoute') && ctrlType == 'true'){
            this.dataCntrl.changeRoute=true;
          }
          if(this.dataCntrl.changeRoute && ctrlType == 'true'){
            this.utility.changeKey = 1;
          }else if(ctrlType != 'true'){
            this.utility.changeKey = (ctrlType == 'true') ? 1 : 2;
          }

        }else{
          if(ctrlType=='vehicle'){
            this.isDuplicate=true;
          }
          if(!this.dataCntrl.hasOwnProperty('changeVehicle') && ctrlType == 'vehicle'){
            this.dataCntrl.changeVehicle=true;
          }
          if(this.dataCntrl.changeVehicle && ctrlType == 'vehicle'){
            this.utility.changeKey = 3;
          }else{
            this.utility.changeKey = 1;
          }
            //this.utility.changeKey = 3;
        }


        //console.log('****ctrlType : ', ctrlType + ' | ' + this.utility.changeKey);
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          this.disableBtn = true;
          //console.log('This is Admin')
        }
      });
      this.getCarrier();
      setTimeout(() => {
        this.getApplication();
        this.getNonPermitTypeInfo();
        if(this.dataCntrl.changeRoute){
          this.utility.activeTab = 0;

        }

      }, 400);
    }
    if (this.router.url.indexOf('change') > 0 && this.router.url.indexOf('selected-vehicle')>0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];

        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          this.disableBtn = true;
          //console.log('This is Admin')
        }
      });
      this.getCarrier();
      setTimeout(() => {
        this.getApplication();
        this.getNonPermitTypeInfo();
        this.utility.activeTab = 2;

      }, 400);
    }
    if(this.router.url.indexOf('correction')>0){
      this.activeRoute.params.subscribe((params: Params) => {
        this.isDuplicate=true;
        this.dataCntrl.application.id = params['id'];
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          this.disableBtn = true;
          //console.log('This is Admin')
        }
      });
      this.getCarrier();
      setTimeout(() => {
        this.getApplication();
        this.getNonPermitTypeInfo();
      }, 400);
    }
    if (this.router.url.indexOf('edit') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        const isSelectedVehicle = params['isSelectedVehicle'];
        if(isSelectedVehicle){
          //console.log(isSelectedVehicle);
          this.utility.activeTab = 2;
        }
      });
      this.getCarrier();
      this.getApplication();
    }
  }


  getCarrier() {
    if (this.dataCntrl.carrierID !== -1) {
      this.pageload = true;
      this.carrierService.getById(this.dataCntrl.carrierID).subscribe(result => {
        this.setCarrierData(result);
        this.pageload = false;
      }, error => {
        this.pageload = false;
        //console.log(error);
      });
    }

  }

  setCarrierData(data) {
    data.account_balance = data.account_balance != 0 ? this.currformat.transform(parseFloat(data.account_balance)) : 'R 0.00';
    this.dataCntrl.carrier = data;
    $("#carrierName").html(data.name);
    //console.log(this.dataCntrl.carrier);
    this.dataCntrl.application.carrier_id = data.id;
    this.dataCntrl.application.person_id = data.person_id;
  }
  getApplication() {
    if (this.dataCntrl.application.id !== null && this.dataCntrl.application.id !== undefined) {
      let id: any = "";
      // if (this.dataCntrl.isSaveAndCon) {
      //   id = this.dataCntrl.application.id
      // } else {
        id = this.dataCntrl.application.id;
      // }
      this.applicationService.getById(id).subscribe((data:any) => {
        //console.log(data.permit);
        this.selectedPermit = data.permit_type;
      
        $("#carrierName").html(data.carrier.name);
        if (!this.permitDisabled) {
          this.dataCntrl.permits = data.permits;
          this.dataCntrl.application = data;
          this.dataCntrl.application.permit_type_id = data.permit_type_id;
          this.dataCntrl.carrierID = data.carrier_id;
          //this.dataCntrl.permit.id = data.permit.id;
        } else {
          this.dataCntrl.application = data;
          delete this.dataCntrl.application.id;
          //console.log(this.dataCntrl.application.id);
          this.dataCntrl.permit = data.permits;
          this.dataCntrl.application.permit_type_id = data.permit_type_id;
          this.dataCntrl.oldPermit=data.permit;
          this.updateRenewPermit()
        }
        this.referenceNum = data.reference_num;

        this.upliftment = data.status_id == this.permitStatus13;

        this.getPermitTypeForEdit(data.permit_type_id);
      })
    }

  }
  getNonPermitTypeInfo(){
      this.applicationService.getById(localStorage.getItem("oldAppId")).subscribe((data:any) => {
        //console.log(data)
        if(data.permit_type.permit_days > 0){
          this.duration = data.permit_type.permit_days > 0 ? data.permit_type.permit_days + " Days" : null;
        }
        if(data.permit_type.permit_months > 0){
          this.duration = data.permit_type.permit_months > 0 ? data.permit_type.permit_months + " Months" : null;
        }
        if(data.permit_type.permit_years <= 1){
          this.duration = data.permit_type.permit_years > 0 ? data.permit_type.permit_years + " Years" : null;
        }
        
        this.amendTerm = data.permit_type.temp_long_ind;
        this.amendType = data.permit_type.freight_passenger_ind;
        this.isAmend = true;

      });

  }
  getCorrectionPermitType(){
    this.permitTypeService.getById(this.dataCntrl['permit'].permit_type_id).subscribe((type:any) =>{
      if(type.permit_days > 0){
        this.duration = type.permit_days > 0 ? type.permit_days + " Days" : null;
      }
      if(type.permit_months > 0){
        this.duration = type.permit_months> 0 ? type.permit_months + " Days" : null;
      }
      if(type.permit_years > 0){
        this.duration = type.permit_years> 0 ? type.permit_years + " Days" : null;
      }

    })
  }
  getPermitTypeForEdit(id) {
    this.permitTypeService.getById(id).subscribe((x:any) => {
      //console.log(x);
      this.canSave = true;
      //console.log(this.dataCntrl.permittype)
       this.selectedPermit = x;
      // this.dataCntrl.permit = x;
      if(x.permit_days > 0){
        x["duration"] = x.permit_days > 0 ? x.permit_days + (x.permit_days == 1? " Day" : " Days") : null;
      }
      if(x.permit_months > 0){
        x["duration"] = x.permit_months > 0 ? x.permit_months + (x.permit_months == 1? " Month" : " Months") : null;
      }
      if(x.permit_years > 0){
        x["duration"] = x.permit_years > 0 ? x.permit_years + (x.permit_years == 1? " Year" : " Years") : null;
      }
      this.defaultValue = x.duration;
      this.defaultValueType = x.description;
      this.otherPermitType = x.code.substring(0,4) == "OTH-"? true : false;
      if(this.router.url.indexOf('correction') < 0 || this.router.url.indexOf('duplicate') < 0 || this.router.url.indexOf('vehicle') < 0 || this.router.url.indexOf('change') < 0)
      {
        this.vehicleTerm = x.temp_long_ind;
        this.vehicleType = x.freight_passenger_ind;
      }

      this.dataCntrl.selectedtype = x.code + '-' + x.description
      this.dataCntrl.permittypeSelected = true;
      this.selectedPermitId = x.id;
      this.dataCntrl.vehicleType = this.vehicleType;
      
      this.dataCntrl.vehicleTerm = this.vehicleTerm;
      this.dataCntrl.durationSelected = this.defaultValue;
      this.durationSelected= this.defaultValue;
      this.typeSelected = this.defaultValueType;
      this.utility.timetableActive=this.dataCntrl.permittype.timetable_reqd;
      if(this.dataCntrl.changeRoute){
        let flag:any=localStorage.getItem("timetable");
        if(flag!=undefined && flag=='true'){
          this.utility.timetableActive=true;
        }
      }
      if(this.utility.timetableActive){
        this.utility.sequenceNumbers.permitNum=1;
        this.utility.sequenceNumbers.vehicleNum=2;
        this.utility.sequenceNumbers.routesNum=3;
        this.utility.sequenceNumbers.motivationNum=4;
        this.utility.sequenceNumbers.timeTableNum=5;
        this.utility.sequenceNumbers.uploadsNum=6;
        this.utility.sequenceNumbers.cnfNum=7;
      }else{
        this.utility.sequenceNumbers.permitNum=1;
        this.utility.sequenceNumbers.vehicleNum=2;
        this.utility.sequenceNumbers.routesNum=3;
        this.utility.sequenceNumbers.motivationNum=4;
        this.utility.sequenceNumbers.timeTableNum=4;
        this.utility.sequenceNumbers.uploadsNum=5;
        this.utility.sequenceNumbers.cnfNum=6;
      }
      setTimeout(()=>{
        let indexVal: any = document.getElementById("idCtype") as HTMLSelectElement;
        ////console.log(indexVal.selectedIndex);
        if(indexVal != undefined && indexVal!=null){
          this.dataCntrl.permitSelectIndex = indexVal.selectedIndex;
        }
        ////console.log(this.defaultValue);
      },1000);
      if (this.permitDisabled && !this.dataCntrl.isSaveAndCon) {
        this.saveApplication();
      } else {
        this.utility.confirmCtrl = true;
        this.reloadVehicle = true;
      }
      if (this.utility.changeKey == 1) {
        if(this.dataCntrl.changeRoute){
        this.utility.activeTab = 3;
        //console.log('Change Key in app-permit-type = ', this.utility.changeKey);
        }
      } else if (this.utility.changeKey == 2) {
        this.utility.activeTab = 4;
      }else if(this.utility.changeKey ==3){
        this.utility.activeTab = 2;
      }

    })
  }
  getPermitType() {
    this.pageload = true;
    this.permitTypeService.getAll().subscribe((result:any) => {
      result.forEach(element => {
        if (element.is_permit > 0) {
          //duration
          element["duration"] = element.permit_days > 0 ? element.permit_days + " Days" : null;
          element["duration"] = element.permit_months > 0 ? element.permit_months + " Months" : element.duration;
          element["duration"] = element.permit_years  > 0 ? element.permit_years + (element.permit_years ==  1 ? " Year" : " Years") : element.duration;
         
          //num days
          element["num_days"] = element.permit_days;
          element["num_days"] = element.permit_months > 0 ? element.permit_months * 30.4 : element.num_days;
          element["num_days"] = element.permit_years  > 0? element.permit_years * 365.25 : element.num_days;
     

          if (element.is_active && !this.durations.some(d => d.num_days == element.num_days && d.freight_passenger_ind == element.freight_passenger_ind && d.temp_long_ind == element.temp_long_ind))
            this.durations.push({ num_days: element.num_days, duration: element.duration, freight_passenger_ind: element.freight_passenger_ind, temp_long_ind: element.temp_long_ind });

          if (element.is_active){
         
            this.permittype.push(element);
          }
        }
      });


      //console.log(JSON.stringify(this.permittype) + "=================================");

      //console.log(this.durations);
      //console.log(this.permittype);
      //this.permittype = result.filter(x => x.is_active == true);
      //  this.setPermitData(result)
      setTimeout(() => {
        //console.log(this.dataCntrl.permitSelectIndex);
        var indexVal1: any = document.getElementById("idCtype") as HTMLSelectElement;
        if(indexVal1 != undefined && indexVal1 != null){
          indexVal1.selectedIndex = this.dataCntrl.permitSelectIndex;
        }
      }, 100);
      this.setHTMLDATA()
      this.pageload = false;
      this.utility.confirmCtrl = true;

    }, error => {
      this.pageload = false;
      //console.log(error);
    });
  }
  durationChange(durationSelected) {
    this.durationSelected = durationSelected.value;
    //console.log(this.durationSelected);
    this.dataCntrl.durationSelected = this.durationSelected;
    // this.defaultValueType = null
  }
  onChange() {
    //(JSON.stringify(this.selectedPermit));
    this.canSave = true;
    if (this.dataCntrl.application.id === undefined || this.dataCntrl.application.id === null) {

      //console.log(this.dataCntrl.application.id);
      this.dataCntrl.permittypeSelected = true;
      this.dataCntrl.application.permit_type_id = this.selectedPermit.id;
      this.dataCntrl.selectedtype = this.selectedPermit.code + '-' + this.selectedPermit.description;
      this.utility.timetableActive=this.selectedPermit.timetable_reqd;
      if(this.utility.timetableActive){
        this.utility.sequenceNumbers.permitNum=1;
        this.utility.sequenceNumbers.vehicleNum=2;
        this.utility.sequenceNumbers.routesNum=3;
        this.utility.sequenceNumbers.motivationNum=4;
        this.utility.sequenceNumbers.timeTableNum=5;
        this.utility.sequenceNumbers.uploadsNum=6;
        this.utility.sequenceNumbers.cnfNum=7;
      }else{
        this.utility.sequenceNumbers.permitNum=1;
        this.utility.sequenceNumbers.vehicleNum=2;
        this.utility.sequenceNumbers.routesNum=3;
        this.utility.sequenceNumbers.motivationNum=4;
        this.utility.sequenceNumbers.uploadsNum=5;
        this.utility.sequenceNumbers.cnfNum=6;
      }
      this.dataCntrl.permittype = this.selectedPermit;
      this.selectedPermitId = this.selectedPermit.id;
      let indexVal: any = document.getElementById("idCtype") as HTMLSelectElement;
      if(indexVal != undefined && indexVal != null)
      {
      this.dataCntrl.permitSelectIndex = indexVal.selectedIndex;
      }
      this.checktempnum( this.dataCntrl.carrierID , this.dataCntrl.application.permit_type_id, this.dataCntrl.permittype.num_renewals_allowed, this.dataCntrl.permittype.freight_passenger_ind, this.dataCntrl.permittype.temp_long_ind);
     
    } else {

      //console.log(this.dataCntrl.application.id);
      // this.showModal.showYesNo('Update Permit Type', 'You have changed the permit type. You will need to start your application again.', `Do you want to continue?`, 'Yes', 'No')
      //   .subscribe((isConfirmed) => {
         
      //     if (isConfirmed) {
      //       this.dataCntrl.permittypeSelected = true;
      //       this.dataCntrl.application.permit_type_id = this.selectedPermitId;
      //       this.dataCntrl.selectedtype = this.selectedPermit.code + '-' + this.selectedPermit.description;
      //       this.dataCntrl.permittype = this.selectedPermit;
      //       this.selectedPermitId = this.selectedPermitId;
      //       let indexVal: any = document.getElementById("idCtype") as HTMLSelectElement;
      //       //console.log(indexVal.selectedIndex);
      //       if(indexVal != undefined && indexVal != null)
      //       {
      //         this.dataCntrl.permitSelectIndex = indexVal.selectedIndex;
      //       }
      //       this.utility.timetableActive=this.selectedPermit.timetable_reqd;
      //       if(this.utility.timetableActive){
      //         this.utility.sequenceNumbers.permitNum=1;
      //         this.utility.sequenceNumbers.vehicleNum=2;
      //         this.utility.sequenceNumbers.routesNum=3;
      //         this.utility.sequenceNumbers.motivationNum=4;
      //         this.utility.sequenceNumbers.timeTableNum=5;
      //         this.utility.sequenceNumbers.uploadsNum=6;
      //         this.utility.sequenceNumbers.cnfNum=7;
      //       }else{
      //         this.utility.sequenceNumbers.permitNum=1;
      //         this.utility.sequenceNumbers.vehicleNum=2;
      //         this.utility.sequenceNumbers.routesNum=3;
      //         this.utility.sequenceNumbers.motivationNum=4;
      //         this.utility.sequenceNumbers.uploadsNum=5;
      //         this.utility.sequenceNumbers.cnfNum=6;
      //       }
      //       this.checktempnum( this.dataCntrl.carrierID , this.dataCntrl.application.permit_type_id, this.dataCntrl.permittype.num_renewals_allowed, this.dataCntrl.permittype.freight_passenger_ind, this.dataCntrl.permittype.temp_long_ind);
      //       this.saveApplication();


      //     } else {
      //       return;
      //     }
      //   });
        this.confirmDialogService.confirmThis('You have changed the permit type. You will need to start your application again. Do you want to continue?', () => {  
          
          this.dataCntrl.permittypeSelected = true;
          this.dataCntrl.application.permit_type_id = this.selectedPermitId;
          this.dataCntrl.selectedtype = this.selectedPermit.code + '-' + this.selectedPermit.description;
          this.dataCntrl.permittype = this.selectedPermit;
          this.selectedPermitId = this.selectedPermitId;
          let indexVal: any = document.getElementById("idCtype") as HTMLSelectElement;
          //console.log(indexVal.selectedIndex);
          if(indexVal != undefined && indexVal != null)
          {
            this.dataCntrl.permitSelectIndex = indexVal.selectedIndex;
          }
          this.utility.timetableActive=this.selectedPermit.timetable_reqd;
          if(this.utility.timetableActive){
            this.utility.sequenceNumbers.permitNum=1;
            this.utility.sequenceNumbers.vehicleNum=2;
            this.utility.sequenceNumbers.routesNum=3;
            this.utility.sequenceNumbers.motivationNum=4;
            this.utility.sequenceNumbers.timeTableNum=5;
            this.utility.sequenceNumbers.uploadsNum=6;
            this.utility.sequenceNumbers.cnfNum=7;
          }else{
            this.utility.sequenceNumbers.permitNum=1;
            this.utility.sequenceNumbers.vehicleNum=2;
            this.utility.sequenceNumbers.routesNum=3;
            this.utility.sequenceNumbers.motivationNum=4;
            this.utility.sequenceNumbers.uploadsNum=5;
            this.utility.sequenceNumbers.cnfNum=6;
          }
          this.checktempnum( this.dataCntrl.carrierID , this.dataCntrl.application.permit_type_id, this.dataCntrl.permittype.num_renewals_allowed, this.dataCntrl.permittype.freight_passenger_ind, this.dataCntrl.permittype.temp_long_ind);
          this.saveApplication();

      
        }, () =>  {  
          return;
        }) 

    }


  }
  setPermitData(data) {
    data.forEach(element => {
      element.fee = this.currformat.transform(parseFloat(element.current_fee));
    });
    // this.permittype = data;

    if (this.dataCntrl.isViewEditControl == true) {
      this.editMode = this.dataCntrl.editMode;
      //   this.setSelectedType();
    }
  }

  setHTMLDATA() {

    if (environment.authWebApi.systemData != null) {
      let link = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'iCBMSLinks2');
      let help = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'iCBMSLand2');
      this.linkhtml = this.sanitizer.bypassSecurityTrustHtml(link.Value);
      this.helphtml = this.sanitizer.bypassSecurityTrustHtml(help.Value);

      //console.log(this.helphtml);
    }
  }

  setSelectedType() {
    this.selectedIndex = this.permittype.findIndex(p => p.id == 11);    
  }

  onSelectType(index, item) {
    if (this.dataCntrl.processStarted == true) {
      this.dataCntrl.disableTypes = true;
      
      this.toastr.warning('Permit Type', `Permit type cannot be changed once the application process has been started. Please delete this application and start again.`)
    } else {
      this.selectedIndex = index;
      this.dataCntrl.permittypeSelected = true;
      this.dataCntrl.application.permit_type_id = item.id;
      this.dataCntrl.selectedtype = `${item.code} - ${item.description}`;
      this.dataCntrl.permittype = item;
    }
  }
  selectVehicleTerm(termVal) {
    this.vehicleTerm = termVal;
    this.dataCntrl.vehicleTerm = this.vehicleTerm;
    this.utility.timetableActive=false;
    this.defaultValueType = null;


    if(this.utility.timetableActive){
      this.utility.sequenceNumbers.permitNum=1;
      this.utility.sequenceNumbers.vehicleNum=2;
      this.utility.sequenceNumbers.routesNum=3;
      this.utility.sequenceNumbers.timeTableNum=5;
      this.utility.sequenceNumbers.uploadsNum=6;
      this.utility.sequenceNumbers.motivationNum=4;
      this.utility.sequenceNumbers.cnfNum=7;
    }else{
      this.utility.sequenceNumbers.permitNum=1;
      this.utility.sequenceNumbers.vehicleNum=2;
      this.utility.sequenceNumbers.routesNum=3;
      this.utility.sequenceNumbers.motivationNum=4;
      this.utility.sequenceNumbers.uploadsNum=5;
      this.utility.sequenceNumbers.cnfNum=6;
    }
  }

  checktempnum(carrierid, permittypeid, permittypemaxallow, freightpassind, temporlong)
  {

    if(temporlong == 1) 
    {
       this.permitService.checkpermnum(carrierid, permittypeid).subscribe((result:any) => {
      // this.permitService.checkpermnum(36, 13).subscribe(result => {

     
     
        if(!this.isFreight ) 
        {
          if(result.length != 0)
          {
              var totalpermits = result[0].total;
              this.maxallowedpermits = permittypemaxallow;
              //console.log(permittypemaxallow);
              if(totalpermits == (permittypemaxallow - 1))
              {
                this.toastr.warning('Please note that you have already received '+ totalpermits + ' temporary permits of this type. You will have to apply for a Long-Term Permit before you can apply for another temporary permit of this type', 'Permit Type');
              }
    
              if(totalpermits == permittypemaxallow)
              {
                this.disableBtn = true;
                this.toastr.warning('Please note that you have already received '+ totalpermits + ' temporary permits of this type. You will have to apply for a Long-Term Permit before you can apply for another temporary permit of this type', 'Permit Type');
                this.permitService.getpermappbycarrier(carrierid,freightpassind).subscribe((data:any) => {
                  // this.permitService.getpermappbycarrier(36,2).subscribe(data => {
                  //console.log(JSON.stringify(data));
                  //console.log('Array lenght: ' + data.length)
    
                  if(typeof data !== 'undefined' && data.length > 0)
                  {
                  this.carrierapplist = data;
                  this.showcarapplist= true;
                  }
                });
              }
          }
        }
      });
  }
  }

  selectedApplication(event,item){
    this.selectedappid = item.appid
    this.disableBtn = false;
    this.isFreight = (event == '1');
   
  }
  selectVehicleType(typeVal) {
    // //console.log(typeVal);
    this.vehicleType = typeVal;
  
    this.dataCntrl.vehicleType = this.vehicleType;
    this.defaultValueType = null;
    this.isFreight = (typeVal == '1');
   
    setTimeout(()=>{
      if($("#idCtype").val()=='null' || $("#idCtype").val()==null){
        this.utility.timetableActive=false;
      //   this.utility.sequenceNumbers.permitNum=1;
      // this.utility.sequenceNumbers.vehicleNum=2;
      // this.utility.sequenceNumbers.routesNum=3;
      // this.utility.sequenceNumbers.uploadsNum=4;
      // this.utility.sequenceNumbers.cnfNum=5;

      }else{
        this.utility.timetableActive=true;
      this.utility.sequenceNumbers.timeTableNum=5;
      this.utility.sequenceNumbers.uploadsNum=6;
      this.utility.sequenceNumbers.cnfNum=7;
      }
    },300);

  }

  myRef(reference) {
    //console.log(reference)
    this.referenceNum = reference;
  }
  saveApplication() {
    //console.log(this.dataCntrl);

    if (!this.permitDisabled && this.selectedPermit == null || this.selectedPermit == "null") {
      this.toastr.warning('Please select your Permit Type ', 'Permit Type');
      this.pageload = false;
      return false;
    }
    // if(!this.referenceNum){
    //   return this.toastr.warning('Please fill in your Reference','Permit Type');
    //  }
    this.pageload = true;

    this.dataCntrl.application.date_modified = this.dataCntrl.application.date_created = new Date();
    this.dataCntrl.application.user_modified = this.dataCntrl.application.user_created = environment.authWebApi.userData.User.FirstName;
    this.dataCntrl.application.reference_num = this.referenceNum;
    // if(this.dataCntrl.permit.permit_type_id === undefined){
    //   this.pageload = false;
    //   return this.toastr.warning('Please select Permit Type first!','Permit Type');
    // }
    //console.log(this.dataCntrl);
    //console.log(this.dataCntrl.application.id)
    if ((this.dataCntrl.application.id == undefined || this.dataCntrl.application.id == null)) {
      let object: any = Object();
      object['date_modified'] = this.dataCntrl.application.date_modified;
      object['user_modified'] = this.dataCntrl.application.user_modified;
      object['reference_num'] = this.dataCntrl.application.reference_num;
      object['permit_type_id'] = this.dataCntrl.application.permit_type_id;
      object['person_id'] = this.dataCntrl.application.person_id;
      object['carrier_id'] = this.dataCntrl.carrierID;
      object['date_created'] = this.dataCntrl.application.date_created;
      object['user_created'] = this.dataCntrl.application.user_created;

//person_id
      let oldResult: any = this.dataCntrl.application;
      this.applicationService.postApplication(object)
        .subscribe(result => {
          if (this.permitDisabled) {
            this.dataCntrl.application = oldResult;
            this.dataCntrl.isSaveAndCon = true;
            this.dataCntrl.renewApplication = result;
            this.dataCntrl.permit.is_valid=false;
          } else {
            this.dataCntrl.application = result;
          }

          this.tabload = false;
          
          this.pageload = false;
          this.applicationService.setTab(2);
          
          // this.dataCntrl.permits.forEach(permit => {
          //   permit.permit_type_id = result.permit_type_id;
          //   permit.application_id = result.id;
          // });
         
          //this.savePermit();
         // this.pageload = false;
          this.reloadVehicle = true;



        },
          error => {
            //  this.tabload = false;
            this.toastr.error('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.', error)

            // this.showModal.showError('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.', error);
            return;
          });
    } else {
      //console.log(this.dataCntrl.permit);

      // this.dataCntrl.application.motivation_detail = null;
      // this.dataCntrl.application.route_id = null;
      this.updateApplication();
      

    }

  }
  cancelApplication() {
    let prevUrl = localStorage.getItem('previousUrl');
    if (prevUrl.search('/permit/approval') != -1) {
      this.router.navigate(['/permit/approval/']);
    } else if (prevUrl.search('/carrier/permit/application/mypermits') != -1) {
      this.router.navigate(['/carrier/permit/application/mypermits/',this.dataCntrl.carrierID]);
    } else {
      this.router.navigate(['/carrier/permit/application/',this.dataCntrl.carrierID]);
    }
  }
    // if (this.dataCntrl.application.id == undefined && this.dataCntrl.application.id == null) {
      // this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
    // } else {
    //   this.showModal.showYesNo('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
    //     .subscribe((isConfirmed) => {
    //       if (isConfirmed) {
    //         this.deleteApplication()
    //       } else {
    //         return;
    //       }
    //     });
    // }
  // }
  // deleteApplication() {
  //   //console.log("delete application");
  //   this.pageload = true;

  //   this.permitService.deletePermit(this.dataCntrl.permit.id).subscribe(x => {
  //     //console.log(x);
  //     this.deleteApp(this.dataCntrl.application.id);
  //     this.pageload = false;

  //     this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);

  //   })
  //   //this.dataCntrl.application.id
  //   //this.dataCntrl.permit.id
  // }
  // deletePermit(id) {
  //   this.permitService.deletePermit(id).subscribe(x => {
  //     //console.log(x);
  //   })

  // }
  // deleteApp(id) {
  //   this.applicationService.deleteApplication(id).subscribe(x => {
  //     //console.log(x);
  //   })
  // }
  savePermit() {

    this.dataCntrl.permits.forEach(permit => {
    permit.date_modified = this.dataCntrl.permit.date_created = new Date();
    permit.user_modified = this.dataCntrl.permit.user_created = environment.authWebApi.userData.User.FirstName;
    permit.permit_fee = this.dataCntrl.permittype.current_fee == null ? 0 : this.dataCntrl.permittype.current_fee;
    permit.application_fee = this.dataCntrl.permittype.current_application_fee == null ? 0 : this.dataCntrl.permittype.current_application_fee;
    permit.supporting_application_id = this.selectedappid;
    permit.permit_num = 0; 
    permit.renewal_num = 0;
    this.permitService.postPermit(permit)
      .subscribe(result => {
        this.dataCntrl.permit = result;
        //this.dataCntrl.permit.permit_num = this.dataCntrl.permit.id + 100000000;
        this.dataCntrl.permit.permit_num = 0; //Remove permit_num assignment task ---
        this.dataCntrl.permit.renewal_num = 0;
        this.dataCntrl.permit.date_modified = this.dataCntrl.permit.date_created = new Date();
        this.dataCntrl.permit.user_modified = this.dataCntrl.permit.user_created = environment.authWebApi.userData.User.FirstName;
        this.dataCntrl.permit.permit_fee = this.dataCntrl.permittype.current_fee == null ? 0 : this.dataCntrl.permittype.current_fee;
        this.dataCntrl.permit.application_fee = this.dataCntrl.permittype.current_application_fee == null ? 0 : this.dataCntrl.permittype.current_application_fee;
      
      
          this.tabload = false;
          
            this.pageload = false;
            this.applicationService.setTab(2);
          
          this.utility.confirmCtrl = true;
          if (this.permitDisabled) {
            this.utility.confirmCtrl = true;
            this.reloadVehicle = true;
          }
          //this.applicationService.setTab(2);
          //$("#vehicleTypeBtn").click();

      },
        error => {
          this.tabload = false
          this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', error)

          return;
        });
    });
    
  }
  updateRenewPermit(){
    let renewalNum:any=this.dataCntrl.oldPermit.renewal_num;
    if(renewalNum==null){
      renewalNum=0;
    }
    this.dataCntrl.oldPermit.renewal_num=renewalNum+1;
    this.permitService.upadatePermit(this.dataCntrl.oldPermit).subscribe(result => {
      //console.log('-renewla--'+result.renewal_num);
    });
  }
  updatePermit(permit) {

    this.pageload = true;

    // this.dataCntrl.permit.permit_num = this.dataCntrl.permit.id + 100000000;
    permit.date_modified  = new Date();
    permit.user_modified  = environment.authWebApi.userData.User.Username;
    permit.permit_fee = this.dataCntrl.permittype.current_fee == null ? 0 : this.dataCntrl.permittype.current_fee;
    permit.application_fee = this.dataCntrl.permittype.current_application_fee == null ? 0 : this.dataCntrl.permittype.current_application_fee;
    
    this.permitService.upadatePermit(permit).subscribe(result => {
      this.dataCntrl.permits = []; //clear permits
      //$("#vehicleDeleteBtn").click();//vehicleDeleteRouteBtn
      this.dataCntrl.permits.push(result); // push the updated permit into list
      this.reloadVehicle = true;
      this.pageload = false;
      
      //permit id + 100 000 000
    })

  }
  updateApplication() {
    if(this.isEditMode)
    {
      this.dataCntrl.application.status_id = 1;
    }
    
    this.applicationService.putApplication(this.dataCntrl.application).subscribe((x:any) => {
     // $("#vehicleDeleteRouteBtn").click();//vehicleDeleteRouteBtn
      this.dataCntrl.application = x;
      if(this.dataCntrl.permits != null && this.dataCntrl.permits.length > 0)
      {
        this.dataCntrl.permits.forEach(permit => {
          if(this.isEditMode)
          {
            permit.status_id = 1;
          }
            permit.permit_type_id = x.permit_type_id;
            permit.application_id = x.id;
          this.updatePermit(permit);
        });
      }

      //$("#vehicleTypeBtn").click();
      this.applicationService.setTab(2);

    });
  }
  changeView(activeC: number, action = 0) {
    this.ctrlData.currentActive = activeC;
    this.ctrlData.action = action;
  }
  
  getViewApp(){
    //console.log('Inside')
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        this.isProcess = false;
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          //this.disableBtn = true;
          //console.log('This is Admin')
        }
      });
      this.getApplication();
  }

  compareFunction(one: any, two: any) {
    return one.id == two.id;
  }

}
